module.exports = __webpack_public_path__ + "static/media/bmw_apps_close.9be3906f.svg";